import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { newsService } from '@/services/news';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useNewsTranslate() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        id: Number(route.params.id),
        locale: null,
        title: '',
        summary: '',
        content: '',
        hasData: false
    });

    const validations = {
        title: { required },
        summary: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push({ name: ROUTE_NAME_NEWS.INDEX });
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => newsService.getText(model.id, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
            model.summary = data.summary;
            model.content = data.content;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
            model.summary = '';
            model.content = '';
        }
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => newsService.updateText(model.id, model.locale, model.title, model.summary, model.content),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => newsService.removeText(model.id, model.locale),
            onSuccess: fetch
        })
    };

    return { v$, model, localeSupportedOptions, fetch, beforeFetch, actions };
}
